<script>

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from '@/helpers/helper';
import { useAggregatorStore } from '@/store/aggregatorStore'
import Swal from "sweetalert2";

import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false)
        const aggregatorStore = useAggregatorStore();

        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen,
          aggregatorStore,
        };
    },
    page: {
    title: "aggregator",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "aggregator",
      items: [
        {
          text: "Menu",
        },
        {
          text: "aggregator",
          active: true,
        },
      ],
      errors: [],
      aggregator: {},
      aggregators: [],      
      name: "",
      url: "",
      devName: "",
      logo: "",
      publicKey: "",
      privateKey: "",
      secretKey: "",
      mode: "",
      status: true,
      description_en: "",
      description_fr: "",
      description_ru: "",
      description_pt: "",
      loading: false,
      statusHttp: 201,
      length: 0,
    };
  },
  
  methods: {
    toDate(date) {
      return Helper.toDate(date)
    },

    async loadFromStore() {
    
          if (!this.aggregatorStore.list) {
           await  this.aggregatorStore.loadFromApi(true).then(data => {
            this.aggregators = data
            this.aggregator_search = data;
            this.length = this.aggregators.length;
        })
          } else {
            this.aggregators = this.aggregatorStore.list
            this.aggregator_search = this.aggregators;
            this.length = this.aggregators.length;
          }
    },

  async  refresh(){
      await  this.aggregatorStore.loadFromApi(true).then(data => {
            this.aggregators = data
            this.aggregator_search = data;
            this.length = this.aggregators.length;
        });
    },

    addItem() {
        this.errors = [];
        let body = {
        name: this.name,
        url: this.url,
        devName: this.devName,
        logo: this.logo,
        publicKey: this.publicKey,
        privateKey: this.privateKey,
        secretKey: this.secretKey,
        mode: this.mode,
        status: this.status,
        description_en: this.description_en,
        description_fr: this.description_fr,
        description_ru: this.description_ru,
        description_pt: this.description_pt
        }
     this.aggregatorStore.createItem(body);
       this.aggregators = this.aggregatorStore.list
        this.aggregator_search = this.aggregators

    },

    editItem() {
      this.errors = [];
       let body = {
        name: this.name,
        url: this.url,
        devName: this.devName,
        logo: this.logo,
        publicKey: this.publicKey,
        privateKey: this.privateKey,
        secretKey: this.secretKey,
        mode: this.mode,
        status: this.status,
        description_en: this.description_en,
        description_fr: this.description_fr,
        description_ru: this.description_ru,
        description_pt: this.description_pt
      }

      this.aggregatorStore.editItem(this.aggregator.id, body);
      this.aggregators = this.aggregatorStore.list
      this.aggregator_search = this.aggregators

     
    },
    
    deleteIt() {
      this.methodStore.deleteItem(this.aggregator.id);
      this.methods = this.methodStore.list
      this.method_search = this.methods
    },

      compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },
  

    initItem(aggregator, action="edit") {
      this.aggregator = aggregator
      this.initData(aggregator)
      if (action == "delete") {
        this.doesDeleteOpen = true
      } else {
        this.doesEditOpen = true
      }
    },

    initData(item = null) {
      this.name = item != null ? item.name : ""
      this.url = item != null ? item.url : ""
      this.devName = item != null ? item.devName : ""
      this.logo = item != null ? item.logo : ""
      this.publicKey = item != null ? item.publicKey : ""
      this.privateKey = item != null ? item.privateKey : ""
      this.secretKey = item != null ? item.secretKey : ""
      this.mode = item != null ? item.mode : ""
      this.status = item != null ? item.status : ""
      this.description_en = item != null ? item.description_en : ""
      this.description_fr = item != null ? item.description_fr : ""
      this.description_ru = item != null ? item.description_ru : ""
      this.description_pt = item != null ? item.description_pt : ""
    }

    

  },
  mounted() {
    this.loadFromStore()
    this.doesLoadingOpen = false
  },
  watch: {
    doesAddOpen: function() {
      this.errors = []
      if (!this.doesAddOpen) {
        this.initData(null)
      }
    },
    doesEditOpen: function() {
      this.errors = []
      if (!this.doesEditOpen) {
        this.initData(null)
        this.aggregator = null
      }
    },
    doesDeleteOpen: function() {
      if (!this.doesDeleteOpen) {
        this.initData(null)
        this.aggregator = null
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
       <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
        <b-button variant="primary" @click="doesAddOpen = true" class="ms-1">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Ajouter un nouveau
        </b-button>
    </div>
    
    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des aggregateurs</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>aggregateurs</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Aggrégateur</th>
                    <th>Mode</th>
                    <th>Status</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(aggregator) in aggregators" :key="aggregator.id">
                    <th scope="row"  v-on:click="compileToClipboard(aggregator.id)"
                                          style="cursor: pointer">{{ i + 1 }}</th>
                    
                    <td>
                                            <img :src="aggregator?.logo" :alt="aggregator.name" style="height: 35px; width: 35px" class="border rounded-circle">

                      {{ aggregator?.name }}
                    </td>
                    <td>
                      {{ aggregator?.mode }}
                    </td>
                    <td>{{ aggregator.status ? "Oui" : "Non" }}</td>
                     <td>
                      {{ Number(aggregator?.available)}}/{{Number(aggregator?.balance) }}
                    </td>
                    <td>
                      {{ toDate(aggregator?.createdAt) }}
                    </td>
                    <td class="hstack">
                        <b-button class="btn-sm ms-2" @click="initItem(aggregator, 'edit')" variant="success">
                            <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <b-button variant="danger" @click="initItem(aggregator, 'delete')" class="ms-2 btn-sm">
                          <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                        </b-button>
                      <router-link :to="'/aggregators/' + aggregator.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>

    
    

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
        v-model="doesAddOpen"
        id="modal-center"
        centered
        size="lg"
        title="Ajouter un aggegateur"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="addItem()">
          <div class="row">
            
            <div class="col-md-6 mb-3">
              <label for="">Nom</label>
              <input type="text" required v-model="name" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name">{{ errors.name }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Logo</label>
              <input type="url" required v-model="logo" class="form-control">
              <span class="text-danger mt-2" v-if="errors.logo">{{ errors.logo }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Dev Name</label>
              <input type="text" required v-model="devName" class="form-control">
              <span class="text-danger mt-2" v-if="errors.devName">{{ errors.devName }}</span>
            </div>

            <div class="col-md-6 mb-3">
              <label for="">Lien URL</label>
              <input type="url" required v-model="url" class="form-control">
              <span class="text-danger mt-2" v-if="errors.url">{{ errors.url }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Clé Publique</label>
              <input type="text" v-model="publicKey" class="form-control">
              <span class="text-danger mt-2" v-if="errors.publicKey">{{ errors.publicKey }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Clé Privée</label>
              <input type="text" required v-model="privateKey" class="form-control">
              <span class="text-danger mt-2" v-if="errors.privateKey">{{ errors.privateKey }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Clé Secrète</label>
              <input type="text" v-model="secretKey" class="form-control">
              <span class="text-danger mt-2" v-if="errors.secretKey">{{ errors.secretKey }}</span>
            </div>

            <div class="col-md-6 mb-3">
              <label for="">Mode</label>
              <select required v-model="mode" class="form-control">
                <option value="live">Live</option>
                <option value="sandbox">Sandbox</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.status">{{ errors.mode }}</span>
            </div>

            <div class="col-md-6 mb-3">
              <label for="">Description EN</label>
              <textarea required v-model="description_en" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_en">{{ errors.description_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description FR</label>
              <textarea placeholder="" required v-model="description_fr" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_fr">{{ errors.description_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description RU</label>
              <textarea required v-model="description_ru" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_ru">{{ errors.description_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description PT</label>
              <textarea required v-model="description_pt" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_pt">{{ errors.description_pt }}</span>
            </div>
            
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- EDIT MODAL -->
    <b-modal
        v-model="doesEditOpen"
        id="modal-center"
        centered
        size="lg"
        title="Modifier un aggegateur"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="editItem()">
          <div class="row">
            
            <div class="col-md-6 mb-3">
              <label for="">Nom</label>
              <input type="text" required v-model="name" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name">{{ errors.name }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Logo</label>
              <input type="url" required v-model="logo" class="form-control">
              <span class="text-danger mt-2" v-if="errors.logo">{{ errors.logo }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Dev Name</label>
              <input type="text" required v-model="devName" class="form-control">
              <span class="text-danger mt-2" v-if="errors.devName">{{ errors.devName }}</span>
            </div>

            <div class="col-md-6 mb-3">
              <label for="">Lien URL</label>
              <input type="url" required v-model="url" class="form-control">
              <span class="text-danger mt-2" v-if="errors.url">{{ errors.url }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Clé Publique</label>
              <input type="text" v-model="publicKey" class="form-control">
              <span class="text-danger mt-2" v-if="errors.publicKey">{{ errors.publicKey }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Clé Privée</label>
              <input type="text" required v-model="privateKey" class="form-control">
              <span class="text-danger mt-2" v-if="errors.privateKey">{{ errors.privateKey }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Clé Secrète</label>
              <input type="text" v-model="secretKey" class="form-control">
              <span class="text-danger mt-2" v-if="errors.secretKey">{{ errors.secretKey }}</span>
            </div>
            
            <div class="col-md-6 mb-3">
              <label for="">Mode</label>
              <select required v-model="mode" class="form-control">
                <option value="live">Live</option>
                <option value="sandbox">Sandbox</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.status">{{ errors.mode }}</span>
            </div>

            <div class="col-md-6 mb-3">
              <label for="">Description EN</label>
              <textarea required v-model="description_en" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_en">{{ errors.description_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description FR</label>
              <textarea placeholder="" required v-model="description_fr" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_fr">{{ errors.description_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description RU</label>
              <textarea required v-model="description_ru" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_ru">{{ errors.description_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description PT</label>
              <textarea required v-model="description_pt" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_pt">{{ errors.description_pt }}</span>
            </div>
            
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- DELETE MODAL -->
    <b-modal
        v-model="doesDeleteOpen"
        id="modal-center"
        title="Supprimer un échange"
        title-class="font-18"
        hide-footer
        >
        <p class="mb-2">
            Voulez-vous vraiment supprimer l'échange <b>{{ aggregator?.from?.name }} - {{ aggregator?.to?.name }}</b> ?
        </p>
        <div class="hstack mt-2" v-if="!loading">
          <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">Annuler</button>
          <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
        </div>
        <div class="text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    </b-modal>


  </Layout>
</template>
